<template>
  <div>
    <div class="title title-mb">
      <div class="title-block">
        <div class="block"></div>
        <div class="titleText">基本信息</div>
      </div>
    </div>

    <el-form :model="form" ref="form" :rules="rules" label-width="100px">
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <el-form-item
            label="果园编号"
            prop="plantationId"
          >
            <el-select
              v-model="form.plantationId"
              filterable
              placeholder="请选择"
              @change="handleChange"
            >
              <el-option
                v-for="(item, index) in plantationList"
                :key="index"
                :label="item.bizNo+'-'+item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" :xs="12">
          <el-form-item 
            label="检测日期"
            prop="testDateTime"
          >
            <el-date-picker v-model="form.testDateTime" type="date" value-format="yyyy-MM-dd" placeholder="请选择日期"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <el-form-item
            label="果园名称"
          >
            <el-input v-model="form.plantationName" placeholder="自动带出" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" :xs="12">
          <el-form-item
            label="果园区域"
          >
            <el-input v-model="form.locName" placeholder="自动带出" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <el-form-item
            label="农残"
            prop="isPesticideTestPassed"
          >
            <el-select
              v-model="form.isPesticideTestPassed"
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in pesticideTestPassedList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12" :xs="12">
          <el-form-item
            label="重金属"
            prop="isHeavyMetalTestPassed"
          >
            <el-select
              v-model="form.isHeavyMetalTestPassed"
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in heavyMetalTestPassedList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24" :xs="12">
          <el-form-item label="备注">
            <el-input
              :rows="3"
              resize="none"
              type="textarea"
              maxlength="300"
              v-model="form.remark"
              placeholder="300字以内"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="attachment-info">
        <div class="title title-mt title-mb">
          <div class="title-block">
            <div class="block"></div>
            <div class="titleText title-mr">
              <span class="err">*</span>
              <span>检测报告</span>
            </div>
            <el-upload
              class="upload-demo"
              :headers="importHeaders"
              :action="uploadPath"
              accept=".jpg, .jpeg, .png, .pdf"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :on-error="handleAvatarError"
              :before-upload="beforeFileUpload"
              :on-progress="handelProgress"
            >
              <el-button class="line-button title-mr" icon="el-icon-plus">上传附件</el-button>
            </el-upload>
            <span class="err">注：仅支持上传pdf，jpg，png格式文件</span>
          </div>
        </div>

        <Attachment
          v-if="fileData && fileData.length > 0"
          :fileList="fileData"
          :is-examine="true"
          :isEdit="true"
          @on-del="handleDelFile"
          :showFileType="false"
        ></Attachment>
        <div v-else class="no-contract-type">暂无内容</div>
      </div>
      <div class="title title-mt title-mb" v-if="type == 'edit'">
        <div class="title-block">
          <div class="block"></div>
          <div class="titleText">修改原因</div>
          <el-popover
            placement="right-end"
            width="900"
            trigger="manual"
            v-model="visible"
          >
            <div>
              <div class="popover_title">
                <div>修改记录</div>
                <div class="el-icon-circle-close" @click="visible = false"></div>
              </div>
              <TablePublic :colLists="colLists" :showIndex="false" :tableData="tableData" tableHeight="400" :paginationFlag="false">
                <template slot="modificationDesc" slot-scope="scope">
                  <el-tooltip :disabled="!scope.data.modificationDesc" :content="scope.data.modificationDesc" placement="top" popper-class="custom-tooltip-width">
                    <div class="modificationDesc">{{ scope.data.modificationDesc }}</div>
                  </el-tooltip>
                </template>
              </TablePublic>
            </div>
            <el-button slot="reference" class="line-button" @click="visible = true">修改记录</el-button>
          </el-popover>
        </div>
      </div>
      <el-row :gutter="20" v-if="type == 'edit'">
        <el-col :span="24" :xs="12">
          <el-form-item label="修改原因" prop="changeRecordContent">
            <el-input
              :rows="3"
              resize="none"
              type="textarea"
              maxlength="300"
              v-model="form.changeRecordContent"
              placeholder="300字以内"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import CONSTANTS from '@/utils/statusConstants'
import { uploadPath } from '@/api/system/system'
import { getDropPlantationList, getPlantDetail, modifyCropTestReport, getCropTestReportDetail, getAmdRecList } from '@/api/system/manage'
import Attachment from '@/components/attachment.vue'
import TablePublic from '@/components/tablePublic'
export default {
  components: {
    Attachment,
    TablePublic
  },
  props: {
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      visible: false,
      dialogVisible: false,
      pesticideTestPassedList: CONSTANTS.pesticideTestPassedStatus2,
      heavyMetalTestPassedList: CONSTANTS.heavyMetalTestPassedStatus2,
      form: { 
        id: '',
        plantationId: '',
        testDateTime: '',
        isPesticideTestPassed: null,
        isHeavyMetalTestPassed: null,
        changeRecordContent: '',
        attachments: [],
        remark: '',
      },
      rules: {
        plantationId: [{ required: true, message: '请选择', trigger: ['blur', 'change'] }],
        testDateTime: [{ required: true, message: '请选择', trigger: 'blur' }],
        isPesticideTestPassed: [{ required: true, message: '请选择', trigger: ['blur', 'change'] }],
        isHeavyMetalTestPassed: [{ required: true, message: '请选择', trigger: ['blur', 'change'] }],
        changeRecordContent: [{ required: true, message: '请输入', trigger: 'blur' }],
      },
      colLists: [
        {
          prop: 'modificationDesc',
          label: '修改内容',
          isTrue: true,
          formSolt: true,
          align: 'left'
        },
        {
          prop: 'reason',
          label: '修改原因',
          isTrue: true,
          align: 'left'
        },
        {
          prop: 'createDate',
          label: '修改日期',
          isTrue: true,
          width: '100'
        },
        {
          prop: 'createBy',
          label: '修改人',
          isTrue: true,
          width: '100'
        },
      ],
      tableData: [],
      fileData: [],
      plantationList: []
    }
  },
  computed: {
    uploadPath() {
      return uploadPath()
    },
    importHeaders() {
      const token = sessionStorage.getItem('token')
      return { Authorization: 'Bearer ' + token }
    },
  },
  created(){
    this.getDropPlantations()
  },
  methods: {
    getDropPlantations(){
      getDropPlantationList().then(res => {
        if (res.flag) {
          this.plantationList = res.data
        }
      })
    },
    getDetails(row) {
      getCropTestReportDetail(row.id).then((res) => {
        if (res.flag) {
          let row = res.data
          this.form = Object.assign(this.form, {
            ...row,
            locName: this.formatLocal(row.locDetails, 3)
          })
          this.fileData =
            (row.attachments &&
              row.attachments.map((f) => {
                return {
                  ...f,
                  fileUrl: f.url,
                  fileName: f.name,
                  fileType: f.type,
                  fileSuffix: f.name.substring(f.name.lastIndexOf('.') + 1)
                }
              })) ||
            []
          this.getAmdRecList(row.id)
        }
      })
    },
    getAmdRecList(id){
      getAmdRecList({formId: id, formType: 'crop_test_report'}).then(res => {
        if (res.flag) {
          this.tableData = res.data.map(d=>{
            d.createDate = this.parseTime(d.createTime, '{y}-{m}-{d}')
            return d
          })
        }
      })
    },
    submit() {
      return new Promise((resolve, reject) => {
        this.$refs['form'].validate(async (valid) => {
          if (valid) {
            if (!this.fileData.length) {
              this.$message.error('请上传附件')
              return reject()
            }
            this.form.attachments =
              this.fileData &&
              this.fileData.map((f) => {
                return {
                  url: f.fileUrl,
                  name: f.fileName,
                  type: f.fileType,
                }
              })
            if(this.type == 'edit') this.form.changeRecordFlag = true
            let result = await modifyCropTestReport(this.form, this.type)
            if (result.code == 200 && result.flag) {
              this.$message.success(`${this.type == 'edit'?'修改':'提交'}成功`)
              resolve()
            } else {
              this.$message.error(result.message)
              reject()
            }
          } else {
            reject()
          }
        })
      })
    },
    reset() {
      // this.fileData = []
      // this.resetForm('form')
      // this.form.plantationName = ''
      // this.form.locName = ''
      // this.form.attachments = []
      // this.form.remark = ''
      // this.form.id = ''
      // this.visible = false
    },
    handleChange(value) {
      getPlantDetail(value).then((res) => {
        if (res.flag) {
          let row = res.data
          this.form = Object.assign(this.form, {
            plantationBizNo: row.bizNo,
            plantationName: row.name,
            ownerName: row.ownerName,
            ownerContact: row.ownerContact,
            provinceCode: row.provinceCode,
            cityCode: row.cityCode,
            districtCode: row.districtCode,
            streetCode: row.streetCode,
            villageCode: row.villageCode,
            fieldCode: row.fieldCode,
            locDetails: row.locDetails,
            locName: this.formatLocal(row.locDetails, 3)
          })
          this.$forceUpdate()
        }
      })
    },
    handleAvatarError() {
      this.$message.error('上传失败')
      this.$emit('on-upload', { fileUploading: false })
    },
    handelProgress() {
      this.$emit('on-upload', { fileUploading: true })
    },
    handleAvatarSuccess(res) {
      const fileType = this.fileInfo(res.data).type
      const fileName = this.fileInfo(res.data).name
      const fileUrl = this.fileInfo(res.data).url
      const fileSuffix = this.fileInfo(res.data).suffix
      this.fileData.push({
        fileName,
        fileType,
        fileUrl,
        fileSuffix
      })
      this.$message.success('上传成功！')
      this.$emit('on-upload', { fileUploading: false })
    },
    handleDelFile(data) {
      this.fileData.splice(data.index, 1)
    },
  },
}
</script>

<style scoped lang='less'>
@import '../../../../assets/form.less';
/deep/ .el-select, .el-date-editor {
  width: 100%;
}
.err {
  color: red;
  font-size: 14px;
}
</style>